import { Routes } from "@angular/router";

import { DashboardComponent } from "./dashboard.component";
import { AddComponent } from "./add/add.component";
import { TravelsComponent } from "./travels/travels.component";
import { RefillsComponent } from "./refills/refills.component";
import { SettingsComponent } from "./settings/settings.component";
import { AdminComponent } from "./admin/admin.component";
import { AdminAvailableVehiclesComponent } from "./admin-available-vehicles/admin-available-vehicles.component";
import { BackofficeComponent } from "./backoffice/backoffice.component";
import { SuperadminToolsComponent } from "./superadmin-tools/superadmin-tools.component";
import { CreateParkComponent } from "./superadmin-tools/create-park/create-park.component";
import { ManageProfilesComponent } from "./superadmin-tools/manage-profiles/manage-profiles.component";
import { ManageVehiclesComponent } from "./superadmin-tools/manage-vehicles/manage-vehicles.component";
import { ManageTravelsComponent } from "./superadmin-tools/manage-travels/manage-travels.component";
import { BrandsAndModelsComponent } from "./superadmin-tools/brands-and-models/brands-and-models.component";
import { ManageVehicleAuthComponent } from "./superadmin-tools/manage-vehicle-auth/manage-vehicle-auth.component";
import { VehicleSearchComponent } from "./superadmin-tools/vehicle-search/vehicle-search.component";
import { ManageRefuelsComponent } from "./superadmin-tools/manage-refuels/manage-refuels.component";

import { AdminAuthGuardService } from "../../auth-n-routing/admin-auth.guard";
import { AuthGuardService } from "../../auth-n-routing/auth-guard.service";
import { SuperAdminAuthGuardService } from "../../auth-n-routing/superadmin-auth.guard";

export const dashboardRoutes: Routes = [
  {
    path: "dashboard",
    component: DashboardComponent,
    children: [
      { path: "dashboard", redirectTo: "add", pathMatch: "full" },
      {
        path: "add",
        component: AddComponent,
        data: { icon: "add", role: "user" },
        canActivate: [AuthGuardService],
      },
      {
        path: "travels",
        component: TravelsComponent,
        data: { label: "Viaggi", role: "user" },
        canActivate: [AuthGuardService],
      },
      {
        path: "refills",
        component: RefillsComponent,
        data: { label: "Rifornimenti", role: "user" },
        canActivate: [AuthGuardService],
      },
      {
        path: "settings",
        component: SettingsComponent,
        data: { icon: "settings", role: "user" },
        canActivate: [AuthGuardService],
      },
      {
        path: "admin",
        component: AdminComponent,
        data: { icon: "shield", role: "admin" },
        canActivate: [AdminAuthGuardService],
      },
      {
        path: "available-vehicles",
        component: AdminAvailableVehiclesComponent,
        data: { icon: "date_range", role: "admin" },
        canActivate: [AdminAuthGuardService],
      },
      {
        path: "back-office",
        component: BackofficeComponent,
        data: { icon: "laptop_chromebook", role: "admin" },
        canActivate: [AdminAuthGuardService],
      },
      {
        path: "super-admin",
        component: SuperadminToolsComponent,
        data: { icon: "build", role: "superadmin" },
        canActivate: [SuperAdminAuthGuardService],
        children: [
          { path: "createpark", component: CreateParkComponent },
          { path: "brands-and-models", component: BrandsAndModelsComponent },
          {
            path: "manage-vehicle-auth/:parkId/:parkName",
            component: ManageVehicleAuthComponent,
          },
          {
            path: "profiles/:parkId/:parkName",
            component: ManageProfilesComponent,
          },
          {
            path: "vehicles/:parkId/:parkName",
            component: ManageVehiclesComponent,
          },
          {
            path: "travels/:parkId/:parkName",
            component: ManageTravelsComponent,
          },
          { path: "calendar", component: AdminAvailableVehiclesComponent },
          { path: "vehicle-search", component: VehicleSearchComponent },
          {
            path: "refuels/:parkId/:parkName",
            component: ManageRefuelsComponent,
          },
        ],
      },
    ],
  },
];
